module.exports = __webpack_public_path__ + "static/media/pic3.7182e2c1.jpg";